import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';
import { Season }       from '@/views/seasons/seasons.types';

export function getAllSeasons(): AxiosPromise {
  return client.get('/setup/seasons');
}

export function putAllSeasons(payload: Season[]): AxiosPromise {
  return client.put('/setup/seasons', { seasons: payload });
}
